import { url } from "inspector";
import * as env from "../../environments/config";
import { createApiFactory } from "../core/apiFactory";
import { serviceAdapter, reduxEnv } from "./services";
import {
  ConfirmSaveUploadPictureByAttendance,
  CreateAttendanceDTO,
  FetchCollaboratorInput,
  SaveCreateAttendanceDTO,
  SaveUploadPictureByAttendance,
} from "./types";
import { KioskoCollaboratorInfo } from "../kiosko";

const cfg = process.env.REACT_APP_ENV ? ((env as any)[process.env.REACT_APP_ENV] ?? {}) : {};
const { API_COLLABORATOR } = cfg;

const api = createApiFactory(serviceAdapter, {
  baseUrl: API_COLLABORATOR,
  redux: reduxEnv,
});

export const fetchCollaboratorInfo = api.make<
  FetchCollaboratorInput,
  { collaboratorInfo: KioskoCollaboratorInfo },
  { collaboratorInfo: KioskoCollaboratorInfo }
>({
  path: "/kiosko/collaboratorInfo",
  method: "GET",
  mapInput: (input) => ({
    queryParams: {
      identificador_app: input.identificador_app,
      id_empresa: input.id_empresa,
    },
    requestConfig: {
      encryptedParams: ["identificador_app", "id_empresa"],
    },
    responseConfig: {
      encryptedResponse: [
        "collaboratorInfo.identificadorApp",
        "collaboratorInfo.idColaborador",
        "collaboratorInfo.[asistencias].id_app",
        "collaboratorInfo.[asistencias].id_empresa",
        "collaboratorInfo.[asistencias].id_registro",
        "collaboratorInfo.foto",
        "collaboratorInfo.[turnos].id_turno",
      ],
    },
  }),
  ui: {
    showLoader: true,
    requireConfirm: false,
    showErrorModal: true,
    showSuccessModal: false,
    confirmText: {
      title: "¿Consultar información del colaborador?",
      subtitle: "Se realizará una petición al servidor.",
      accept: "Continuar",
      cancel: "Cancelar",
    },
    errorText: { title: "No se pudo cargar la información" },
    // si un día quieres trackear progreso visual:
    // progressKey: "fetchCollaboratorInfo"
  },
});

export const saveUploadPictureByAttendance = api.make<
  SaveUploadPictureByAttendance,
  ConfirmSaveUploadPictureByAttendance,
  ConfirmSaveUploadPictureByAttendance
>({
  path: "attendance/upload-picture",
  method: "POST",
  mapInput: (input) => ({
    body: {
      ...(input.zone_id ? { zone_id: input.zone_id } : {}),
      user_modify: input.user_modify,
      url: input.url,
      attendance_id: input.attendance_id,
    },
    requestConfig: {
      encryptedBody: ["zone_id", "user_modify", "url", "attendance_id"],
    },
    responseConfig: {
      encryptedResponse: [],
    },
  }),
  ui: {
    showLoader: true,
    requireConfirm: false,
    showErrorModal: true,
    showSuccessModal: false,
  },
});

export const CreateAttendance = api.make<
  CreateAttendanceDTO,
  SaveCreateAttendanceDTO,
  SaveCreateAttendanceDTO
>({
  path: "v2/attendance/create",
  method: "POST",
  mapInput: (payload) => ({
    body: {
      collaborator_id: payload.collaborator_id,
      company_id: payload.company_id,
      latitude: typeof payload.latitude === "number" ? String(payload.latitude) : payload.latitude,
      longitude:
        typeof payload.longitude === "number" ? String(payload.longitude) : payload.longitude,
      attendance_type: payload.attendance_type,
      origin: "KIOSKO",
      shift_id: payload.idTurno ?? null,
    },
    requestConfig: {
      encryptedBody: ["collaborator_id", "company_id", "latitude", "longitude", "shift_id"],
    },
    responseConfig: {
      encryptedResponse: ["attendance_id"],
    },
  }),
  ui: {
    showLoader: true,
    requireConfirm: false,
    showErrorModal: false,
    showSuccessModal: false,
  },
});
